import endpoints from "../define/endpoints";
import { VIDEO_EXTENSIONS } from "../../constants";

const useGetVideoPreview = (src) => {
  const videoExtensions = VIDEO_EXTENSIONS;

  const extension = videoExtensions.find((ext) => src && src.endsWith(ext));

  if (!extension) return src;

  const imageSrc = src.replace(extension, '.jpg');

  return imageSrc.startsWith(endpoints.bucket) ? imageSrc : endpoints.bucket + imageSrc;
};

export default useGetVideoPreview;